export default "/images/gjensidige-min.avif?24c5b3bd601ba329b4fa819446acbdb8";